import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { ChangePasswordService } from 'src/app/account/services/change-password.service';
import { ErrorModel } from 'src/app/core/models/error.model';
import { AuthService } from 'src/app/core/services/auth.service';
import { LayoutService } from 'src/app/layout/layout.module';
import { ConfiguracaoService } from '../../services/configuracao.service';
import { UpdatePicService } from '../../services/update-pic.service';
import { LocalStorage } from 'src/app/core/utils/local.storage';
import { UsuarioDTOModel } from 'src/app/account/models/usuario-dto.model';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  submit = false;
  formPassword: FormGroup;
  notEqualPassword = '';
  file: File = null;
  profileImage: SafeUrl;
  messageSuccess: string;
  messageError: string;
  uploadPicLoading = false;

  @ViewChild('inputFile') inputFile: ElementRef;

  constructor(
      private formBuilder: FormBuilder,
      private authService: AuthService,
      private changePasswordService: ChangePasswordService,
      private configuracaoService: ConfiguracaoService,
      private layoutService: LayoutService,
      private updatePicService: UpdatePicService,
      private domSanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.formPassword = this.formBuilder.group({
      currentPassword: ['', Validators.compose([Validators.required])],
      newPassword: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
      confirmPassword: ['', Validators.compose([Validators.required, Validators.minLength(8)])]
    });

    this.updatePicService.service().subscribe(foto => {
      if (!foto || foto == "null") {
        const usuarioSistemaDTO: any = LocalStorage.getItem("usuarioSistemaDTO");
        this.profileImage = usuarioSistemaDTO?.foto;
        return;
      }

      this.profileImage = foto;
    });
  }

  onChange(event) {
    this.messageError = '';
    this.file = event.target.files[0];

    if (!['image/jpeg', 'image/png'].includes(this.file.type)) {
      this.messageError = 'Permitido apenas extensões JPEG ou PNG.';
      return;
    }

    if (this.file.size) {
      this.uploadPic();
      this.inputFile.nativeElement.value = null;
    }
  }

  private uploadPic() {
    const usuarioDTO: UsuarioDTOModel = LocalStorage.getItem('usuarioSistemaDTO');
    if (!usuarioDTO || !usuarioDTO.email) {
      this.messageError = 'Erro com os dados do usuário';
      return;
    }

    this.uploadPicLoading = true;

    const formData = new FormData();
    formData.append("file", this.file, this.file.name);
    formData.append("emailProfile", usuarioDTO.email);

    this.configuracaoService.uploadPic(formData).subscribe(result => {
      //console.log(result);
      this.updatePicService.setNewFile(result.foto);
      LocalStorage.setItem("usuarioSistemaDTO", result);
    }, (error: ErrorModel) => {
      console.log(error);
    }).add(() => {
      this.uploadPicLoading = !this.uploadPicLoading;
    });
  }

  submitForm(): void {
    this.notEqualPassword = '';

    if (!this.formPassword.valid) {
      return;
    }

    if (!this.checkEqualsPassword()) {
      this.notEqualPassword = 'A confirmação da senha não esta adequada.';
      return;
    }

    this.messageSuccess = null;
    this.messageError = null;
    this.submit = true;
    const body = this.formPassword.value;
    this.changePasswordService
        .createRequest(body)
        .pipe(finalize(() => {
          this.submit = false;
        }))
        .subscribe(
            (results) => {
              this.messageSuccess = 'Senha atualizada com sucesso.';
            },
            (error: ErrorModel) => {
              console.log(error);
              this.messageError = 'Erro ao tentar atualizar senha.';
            }
        ).add(() => this.formPassword.reset());
  }

  private checkEqualsPassword(): boolean {
    return this.formPassword.get('newPassword').value.trim()
        === this.formPassword.get('confirmPassword').value.trim();
  }

}
